import { BYTES_PER_KILOBYTE, BYTES_PER_MEGABYTE } from './bytes.constants';

// Maximum bytes per file, shared by frontend validation and backend enforcement.
export const MAX_UPLOAD_SIZE_PERFORMANCE_VISUALIZATION = 512 * BYTES_PER_KILOBYTE;
export const MAX_UPLOAD_SIZE_AVATAR_PICTURE = 512 * BYTES_PER_KILOBYTE;
export const MAX_UPLOAD_SIZE_TENANT_LOGO = BYTES_PER_MEGABYTE;
export const MAX_UPLOAD_SIZE_EXTERNAL_MATERIAL_LOGO = BYTES_PER_MEGABYTE;
export const MAX_UPLOAD_SIZE_REPORT_COVER_IMAGE = BYTES_PER_MEGABYTE;

// nginx limits an upload request to 1 MiB, the size upload errors name; a file sent alone keeps 1 KiB of it for the
// multipart overhead.
export const MAX_UPLOAD_REQUEST_SIZE = BYTES_PER_MEGABYTE;
const MAX_SINGLE_FILE_UPLOAD_SIZE = MAX_UPLOAD_REQUEST_SIZE - BYTES_PER_KILOBYTE;

// Maximum compressed ZIP size. The client sends a fixed filename and MIME type; ZIP metadata is already in file.size.
export const MAX_ZIP_SIZE_TEMPLATE_SET = MAX_SINGLE_FILE_UPLOAD_SIZE;
export const MAX_UNPACKED_SIZE_TEMPLATE_SET = 5 * BYTES_PER_MEGABYTE;
export const MAX_UPLOAD_SIZE_STUDENT_IMPORT = MAX_SINGLE_FILE_UPLOAD_SIZE;
